module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"toolbar":{"buttons":{"Logout":"Logout"}}},"ru":{"toolbar":{"buttons":{"Logout":"Выход"}}}}')
  delete Component.options._Ctor
}
